export const getWindowLocation = () => window.location;
//# sourceMappingURL=browser.js.map